import { Button } from "@/components/ui/button";
import { Image } from "@/components/ui/image";
import { Link } from "react-router-dom";

export const NotAuthorisedTemplate = () => {
  return (
    <div className="flex items-center h-full relative w-full">
      <div className="flex items-center h-full relative w-full justify-center flex-col">
        <Image
          src="/images/error-401.svg"
          alt=""
          className="h-[400px] mt-[-100px] mix-blend-multiply"
        />
        <h1 className="pt-4 text-xl font-semibold text-slate-800 dark:text-navy-50">
          You are not authorized
        </h1>
        <div className="py-2 mb-5 text-slate-500 dark:text-navy-200 text-center">
          It seems you don't have permission to access this page. <br />
          Please contact your administrator.
        </div>
        <Link to="/">
          <Button>Back to Home</Button>
        </Link>
      </div>
    </div>
  );
};
